export default "__VITE_ASSET__CIQe6zJC__$_?imageSize__"